<template>
  <v-data-table
    class="default-table-height majorityTable"
    hide-default-footer
    mobile-breakpoint="0"
    :items-per-page="majorityFilter.size"
    :footer-props="{
      'items-per-page-text': 'Linhas por página',
      'first-icon': 'mdi-chevron-up',
      'page-text': '',
      'items-per-page-options': [10, 25, 50, 100],
    }"
    fixed-header
    :headers="headers"
    :height="majorityTableHeight"
    :items="majoritiesView"
    :page="majorityFilter.page"
    :server-items-length="majoritiesTotalElements">
    <!-- Cabeçalho -->
    <template
      v-slot:[`header.protocolStatus`]="{ }">
      <TwoLineCell
        id="protocolStatus"
        :firstLine="isRHProtegido ? '' : 'Protocolo'"
        :firstLineClass="headerFirstLineClass"
        :firstLineStyle="headerFirstLine.style"
        secondLine="Status"
        :secondLineClass="headerSecondLineClass"
        :secondLineStyle="headerSecondLine.style"
      />
    </template>

    <template
      v-slot:[`header.financialGroupCarrier`]="{ }">
      <TwoLineCell
        id="financialGroupCarrier"
        firstLine="Grupo Financeiro"
        :firstLineClass="headerFirstLineClass"
        :firstLineStyle="headerFirstLine.style"
        secondLine="Operadora"
        :secondLineClass="headerSecondLineClass"
        :secondLineStyle="headerSecondLine.style"
      />
    </template>

    <template
      v-slot:[`header.policySub`]="{ }">
      <TwoLineCell
        id="policySub"
        firstLine="Apólice"
        :firstLineClass="headerFirstLineClass"
        :firstLineStyle="headerFirstLine.style"
        secondLine="Subcontrato"
        :secondLineClass="headerSecondLineClass"
        :secondLineStyle="headerSecondLine.style"
      />
    </template>

    <template
      v-slot:[`header.nameDocument`]="{ }">
      <TwoLineCell
        id="nameDocument"
        firstLine="Nome do Beneficiário"
        :firstLineClass="headerFirstLineClass"
        :firstLineStyle="headerFirstLine.style"
        secondLine="CPF"
        :secondLineClass="headerSecondLineClass"
        :secondLineStyle="headerSecondLine.style"
      />
    </template>

    <template
      v-slot:[`header.ageBirthDate`]="{ }">
      <TwoLineCell
        id="ageBirthDate"
        firstLine="Idade"
        :firstLineClass="headerFirstLineClass"
        :firstLineStyle="headerFirstLine.style"
        secondLine="Data de Nascimento"
        :secondLineClass="headerSecondLineClass"
        :secondLineStyle="headerSecondLine.style"
      />
    </template>

    <template
      v-slot:[`header.holderDocument`]="{ }">
      <TwoLineCell
        id="holderDocument"
        firstLine="Nome do Titular"
        :firstLineClass="headerFirstLineClass"
        :firstLineStyle="headerFirstLine.style"
        secondLine="CPF"
        :secondLineClass="headerSecondLineClass"
        :secondLineStyle="headerSecondLine.style"
      />
    </template>

    <template
      v-slot:[`header.kinship`]="{ }">
      <TwoLineCell
        id="kinship"
        firstLine="Parentesco"
        :firstLineClass="headerFirstLineClass"
        :firstLineStyle="headerFirstLine.style"
        secondLine=""
      />
    </template>

    <template
      v-slot:[`header.actions`]="{ }">
      <TwoLineCell
        id="actions"
        firstLine="Ações"
        :firstLineClass="headerFirstLineClass"
        :firstLineStyle="headerFirstLine.style"
        secondLine=""
      />
    </template>

    <!-- Tabela -->
    <template
      v-slot:[`item.protocolStatus`]="{ item }">
      <TwoLineCell
        id="protocolStatus"
        :firstLine="isRHProtegido ? '' : item.externalProtocol"
        :firstLineClass="bodyFirstLineClass"
        :firstLineStyle="bodyFirstLine.style"
        :secondLine="setMajorityStatus(item.majorityStatus, item.coverageExtensionReason)"
        :secondLineClass="
          setMajorityStatus(item.majorityStatus, item.coverageExtensionReason)
            ? bodySecondLineStatusClass
            : bodySecondLineClass"
        :secondLineStyle="
          setMajorityStatus(item.majorityStatus, item.coverageExtensionReason)
            ? bodySecondLineStatus.style
            : bodySecondLine.style"
        :isBadge="Boolean(item.majorityStatus)"
      />
    </template>

    <template
      v-slot:[`item.financialGroupCarrier`]="{ item }">
      <TwoLineCell
        id="financialGroupCarrier"
        :firstLine="item.financialGroupName ? formatter.capitalizeText(item.financialGroupName) : '—'"
        :firstLineClass="bodyFirstLineClass"
        :firstLineStyle="bodyFirstLine.style"
        :secondLine="item.carrierName ? formatter.capitalizeText(item.carrierName) : '—'"
        :secondLineClass="bodySecondLineClass"
        :secondLineStyle="bodySecondLine.style"
      />
    </template>

    <template
      v-slot:[`item.policySub`]="{ item }">
      <TwoLineCell
        id="policySub"
        :firstLine="item.policy"
        :firstLineClass="bodyFirstLineClass"
        :firstLineStyle="bodyFirstLine.style"
        :secondLine="`${item.subcontractNumber} ${item.benefitType}`"
        :secondLineClass="bodySecondLineClass"
        :secondLineStyle="bodySecondLine.style"
      />
    </template>

    <template
      v-slot:[`item.nameDocument`]="{ item }">
      <TwoLineCell
        id="nameDocument"
        :firstLine="formatter.capitalizeText(item.insuredName)"
        :firstLineClass="bodyFirstLineClass"
        :firstLineStyle="bodyFirstLine.style"
        :secondLine="item.insuredDocumentNumber ? formatter.formatCpf(item.insuredDocumentNumber.toString()) : ''"
        :secondLineClass="bodySecondLineClass"
        :secondLineStyle="bodySecondLine.style"
      />
    </template>

    <template
      v-slot:[`item.ageBirthDate`]="{ item }">
      <TwoLineCell
        id="ageBirthDate"
        :firstLine="`${item.insuredAge} anos`"
        :firstLineClass="bodyFirstLineClass"
        :firstLineStyle="bodyFirstLine.style"
        :secondLine="formatter.formatDate(item.birthDate)"
        :secondLineClass="bodySecondLineClass"
        :secondLineStyle="bodySecondLine.style"
      />
    </template>

    <template
      v-slot:[`item.holderDocument`]="{ item }">
      <TwoLineCell
        id="holderDocument"
        :firstLine="formatter.capitalizeText(item.holderName)"
        :firstLineClass="bodyFirstLineClass"
        :firstLineStyle="bodyFirstLine.style"
        :secondLine="item.holderDocumentNumber ? formatter.formatCpf(item.holderDocumentNumber.toString()) : ''"
        :secondLineClass="bodySecondLineClass"
        :secondLineStyle="bodySecondLine.style"
      />
    </template>

    <template
      v-slot:[`item.kinship`]="{ item }">
      <TwoLineCell
        id="kinship"
        :firstLine="formatter.capitalizeText(item.kinshipName)"
        :firstLineClass="bodyFirstLineClass"
        :firstLineStyle="bodyFirstLine.style"
        secondLine=""
      />
    </template>

    <template
      v-slot:[`item.actions`]="{ item }">
      <v-menu
        transition="slide-y-transition"
        offset-y>
        <template
          v-slot:activator="{ on, attrs }">
          <v-btn
            color="primary"
            icon
            v-bind="attrs"
            v-on="on">
            <v-icon>
              mdi-dots-vertical
            </v-icon>
          </v-btn>
        </template>

        <TodoListActions
          :actions="getTodoActions(item)"
          :showIcons="false"
          :useSort="false"
        />
      </v-menu>
    </template>

    <template v-slot:footer="{ props }">
      <v-container
        fluid
        class="px-0 pt-0">
        <v-divider />
        <v-row
          justify="end"
          class="d-flex flex-row align-center fill-height px-8 pt-2"
          style="height: 70px;">
          <div
            class="d-flex flex-row align-center fill-height">
            <span
              style="margin-right: 50px;"
              :class="labelFooter.class"
              :style="labelFooter.style">
              Linhas por página
            </span>

            <v-select
              :value="majorityFilter.size"
              :items="props.itemsPerPageOptions"
              hide-details
              dense
              class="footerSelectItemsPerPage primary--text mt-0"
              color="primary"
              :style="selectFooter.style"
              append-icon="mdi-chevron-down"
              @change="setSize"
            />
          </div>

          <span
            v-if="majoritiesTotalElements"
            :class="labelFooter.class"
            :style="labelFooter.style">
            {{
              rangePagination
            }}
          </span>

          <v-btn
            icon
            :disabled="majorityFilter.page === 0"
            @click="setMajorityFilter({page: majorityFilter.page-1})">
            <v-icon
              size="24"
              color="primary">
              mdi-chevron-left
            </v-icon>
          </v-btn>

          <v-btn
            icon
            :disabled="((majorityFilter.page+1) * props.pagination.itemsPerPage) >= props.pagination.itemsLength"
            @click="setMajorityFilter({page: majorityFilter.page+1})"
          >
            <v-icon
              size="24"
              color="primary">
              mdi-chevron-right
            </v-icon>
          </v-btn>
        </v-row>
      </v-container>
    </template>
  </v-data-table>
</template>

<script>
import TodoListActions from '../../../TodoList/TodoListActions.vue';
import TwoLineCell from '@/components/Default/TwoLineCell.vue';
import { mapActions, mapGetters, mapMutations } from 'vuex';

import MovementRecordsMixin from '@/shared/mixins/movementRecords/movementRecordsMixin';
import InsuranceCarriersMixin from '@/shared/mixins/sdi/insuranceCarriersMixin';
import FinancialGroupsMixin from '@/shared/mixins/sdi/financialGroupsMixin';
import MajorityMixin from '@/shared/mixins/majority/majorityMixin';
import ContractsMixin from '@/shared/mixins/sdi/contractsMixin';
import MajorityRules from '../../rules/majorityRules.js';

import Formatters from '@/shared/formatters/formatters';

export default {
  name: "MajorityTable",

  components: {
    TodoListActions,
    TwoLineCell,
  },

  data: () => ({
    formatter: null,

    kinships: [],
  }),

  mixins: [
    InsuranceCarriersMixin,
    MovementRecordsMixin,
    FinancialGroupsMixin,
    ContractsMixin,
    MajorityRules,
    MajorityMixin,
  ],

  methods: {
    ...mapActions({
      setMajorityFilter: 'majority/setMajorityFilter',
    }),

    ...mapMutations({
      openRequestModal: 'majority/openRequestModal',
    }),

    setSize(size) {
      this.setMajorityFilter({size: size, page: 0});
    },

    setMajorityStatus(majorityStatus, majorityCoverageExtensionReason) {
      let coverageDescription = '';

      if (majorityCoverageExtensionReason) {
        const coverage = this.coverages.find(
          (coverage) => coverage.id === parseInt(majorityCoverageExtensionReason)
        );

        if (coverage) {
          coverageDescription = coverage.description;
        }
      }

      switch(majorityStatus) {
        case 'EXTENSION':
          return 'Permanência solicitada';

        case 'EXCLUSION':
          return 'Exclusão solicitada';

        case 'EXTENDED':
          if (coverageDescription) {
            return `Permanência confirmada - ${coverageDescription}`;
          }

          return 'Permanência confirmada';

        case 'EXCLUDED':
          return 'Exclusão confirmada';

        case 'CANCELED':
          return 'Cancelado';

        default:
          return '';
      }
    },

    getTodoActions(beneficiary) {
      const actions = [
        {
          label: 'Solicitar a Exclusão',
          icon: '',
          color: 'primary',
          condition: this.hasPermission('sdi_maioridade_acao_exclusao'),
          disabled: !(beneficiary.majorityStatus === 'PENDING' && beneficiary.externalProtocolStatus === 'closed'),
          tootltipMessage: this.getTooltipMessage(beneficiary),
          handler: () => this.openRequestModal({ majorityStatus: 'EXCLUSION', beneficiary: beneficiary }),
        },
        {
          label: 'Solicitar Permanência',
          icon: '',
          color: 'primary',
          condition: this.hasPermission('sdi_maioridade_acao_permanencia'),
          disabled: !(beneficiary.majorityStatus === 'PENDING' && beneficiary.externalProtocolStatus === 'closed'),
          tootltipMessage: this.getTooltipMessage(beneficiary),
          handler: () => this.openRequestModal({ majorityStatus: 'COVERAGE' , beneficiary: beneficiary }),
        },
      ];

      return actions;
    },
  },

  computed: {
    ...mapGetters({
      majoritiesTotalElements: 'majority/majoritiesTotalElements',
      majoritiesTotalPages: 'majority/majoritiesTotalPages',
      majorityFilter: 'majority/majorityFilter',
      isRHProtegido: 'user-info/isRHProtegido',
      majorities: 'majority/majorities',
    }),

    majoritiesView() {
      return this.majoritiesViewValidation(this.majorities);
    },

    rangePagination() {
      const page = this.majorityFilter.page;
      const size = this.majorityFilter.size;
      const total = this.majoritiesTotalElements;

      const start = total === 0 ? 0 : page * size + 1;
      const end = Math.min((page + 1) * size, total);

      return `${start}–${end} de ${total}`;
    },

    majorityTableHeight() {
      const viewportHeight = window.innerHeight;
      const tableHeight = -560 + viewportHeight;
      const isFullScreen = tableHeight <= 1080;
      const hasMoreThanTen = this.majoritiesView && this.majoritiesView.length >= 10;

      if (!hasMoreThanTen) return null;
      if (!isFullScreen) return 455;
      return tableHeight < 400 ? 400 : tableHeight;
    },

    headers() {
      const xippPlatformClass = this.$vuetify.breakpoint.mdAndDown ? {class: 'platformXippTable'} : {};
      return [
        { value: 'protocolStatus', sortable: false, ...xippPlatformClass },
        { value: 'financialGroupCarrier', sortable: false, ...xippPlatformClass },
        { value: 'policySub', sortable: false, ...xippPlatformClass },
        { value: 'nameDocument', sortable: false, ...xippPlatformClass },
        { value: 'ageBirthDate', sortable: false, ...xippPlatformClass },
        { value: 'holderDocument', sortable: false, ...xippPlatformClass },
        { value: 'kinship', sortable: false, ...xippPlatformClass },
        { value: 'actions', width: '60px', sortable: false, align: 'center' },
      ]
    },

    headerFirstLineClass() {
      return this.$vuetify.breakpoint.mdAndDown ? `${this.headerFirstLine.class} platformXippTable` : this.headerFirstLine.class
    },

    headerSecondLineClass() {
      return this.$vuetify.breakpoint.mdAndDown ? `${this.headerSecondLine.class} platformXippTable` : this.headerSecondLine.class
    },

    bodyFirstLineClass() {
      return this.$vuetify.breakpoint.mdAndDown ? `${this.bodyFirstLine.class} platformXippTable` : this.bodyFirstLine.class
    },

    bodySecondLineClass() {
      return this.$vuetify.breakpoint.mdAndDown ? `${this.bodySecondLine.class} platformXippTable` : this.bodySecondLine.class
    },

    bodySecondLineStatusClass() {
      return this.$vuetify.breakpoint.mdAndDown ? `${this.bodySecondLineStatus.class} platformXippTable` : this.bodySecondLineStatus.class
    },
  },

  created() {
    this.formatter = new Formatters();
  },

  async mounted() {
    await this.loadKinships();
  }
}
</script>

<style lang="scss">
#protocolStatus .platformXippTable {
  min-width: 70px !important;
  max-width: 70px !important;
}

#financialGroupCarrier .platformXippTable {
  min-width: 110px !important;
  max-width: 110px !important;
}

#policySub .platformXippTable {
  min-width: 80px !important;
  max-width: 80px !important;
}

#nameDocument .platformXippTable {
  min-width: 140px !important;
  max-width: 140px !important;
}

#ageBirthDate .platformXippTable {
  min-width: 130px !important;
  max-width: 130px !important;
}

#holderDocument .platformXippTable {
  min-width: 112px !important;
  max-width: 112px !important;
}

#kinship .platformXippTable {
  min-width: 80px !important;
  max-width: 80px !important;
}

#actions .platformXippTable {
  max-width: 50px !important;
}

#nameDocument :not(:has(.platformXippTable)){
  max-width: auto !important;
}

#actions {
  min-width: 40px !important;
}

.majorityTable {
  border-radius: 5px !important;
  box-shadow: 0px 2px 6px color-mix(in srgb, var(--v-shadow-base) 26%, transparent) !important;

  > .v-data-table__wrapper {
    border-radius: 5px 5px 0px 0px !important;

    > table {
      > .v-data-table-header {
        border-radius: 5px 5px 0px 0px !important;
        background-color: var(--v-muted-foreground-base) !important;

        > tr {
          height: 90px;
          max-height: 90px;
          border-radius: 5px !important;

          > th {
            padding: 0 1% !important;
            background: var(--v-muted-foreground-base) !important;

            > span {
              color: var(--v-primary-base) !important;
            }
          }
        }
      }

      > tbody > tr {
        height: 70px;
        max-height: 70px;
        > td {
          padding: 0 1% !important;
        }
      }
    }
  }
}

.footerSelectItemsPerPage .v-select__selections {
  > .select__selection {
    margin: 5px 0x 3px 0 !important;
  }

  > input {
    display: none !important;
  }
}

.footerSelectItemsPerPage .v-select__selections {
  display: flex;
  justify-content: center;
  > .v-select__selection.v-select__selection--comma {
    margin: 5px 0px 3px 0 !important;
  }
}
</style>
